import React from "react";

// @mui/material components
import Icon from "@mui/material/Icon";

// @mui/icons-material
import Close from "@mui/icons-material/Close";
import Edit from "@mui/icons-material/Edit";

import Grid from "@mui/material/Grid";

// core components
import { ModoModal, EstadoPedido, ModoReport, TiposResultadoOthello, PopUpResult, TiposInstalacionReserva, EstadoReserva, Roles } from "./othelloConstantes.jsx";
import Button from "./components/Button.jsx";

import saveAs from "file-saver";


import MDAlert from "./components/MDAlert/index.js";
import MDTypography from "./components/MDTypography/index.js";

import OthelloPopUpResult from "./componentsothello/OthelloPopUpResult.jsx";
import OthelloMostrarRetorno from "./componentsothello/OthelloMostrarRetorno.jsx";


import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
} from "react-google-maps";

export function getCurrentDataFormulario(formulario) {
    var object = {};
    //let formulario = document.getElementById('formcliente');
    let formData = new FormData(formulario);
    formData.forEach((value, key) => { object[key] = value });

    return object;
}


export function getFormularioDesdeCurrentData(currentdata) {

    var form_data = new FormData();

    if (currentdata != null && currentdata != "") {
        for (var key in currentdata) {
            form_data.append(key, currentdata[key]);
        }
    }

    return form_data;
}

export function MensajeModalSegunEstado(modo) {

    if (modo == ModoModal.Undo || modo == ModoModal.Back)
        return (<div>Las modificaciones actuales se perderán <p>¿Estas seguro de deshacer los cambios realizados ?</p></div>);
    else if (modo == ModoModal.Delete)
        return "¿Estas seguro de realizar la operacion de eliminar ?"
    else
        return ("");    
}


export function GetGridButtons(item, index, onEdit, onDelete) {

    let botones = [];

    if (onEdit != null)
        botones.push({ color: "success", icon: Edit });

    if (onDelete != null)
        botones.push({ color: "error", icon: Close });

    let fillButtons = botones.map((prop, key) => {
        return (
            <Button iconOnly circular={true} color={prop.color} key={key} onClick={prop.color == "success" ? () => onEdit(item, index) : () => onDelete(item, index)}>
                <prop.icon />
            </Button>
        );
    });

    return fillButtons;
}

export function GetDiaSemana(dia) {
    if (dia == 1)
        return "Lunes";
    else if (dia == 2)
        return "Martes";
    else if (dia == 3)
        return "Miercoles";
    else if (dia == 4)
        return "Jueves";
    else if (dia == 5)
        return "Viernes";
    else if (dia == 6)
        return "Sabado";
    else if (dia == 0)
        return "Domingo";
    else
        return "";
}

export function GetMes(mes) {
    if (mes == 0)
        return "Enero";
    else if (mes == 1)
        return "Febrero";
    else if (mes == 2)
        return "Marzo";
    else if (mes == 3)
        return "Abril";
    else if (mes == 4)
        return "Mayo";
    else if (mes == 5)
        return "Junio";
    else if (mes == 6)
        return "Julio";
    else if (mes == 7)
        return "Agosto";
    else if (mes == 8)
        return "Septiembre";
    else if (mes == 9)
        return "Octubre";
    else if (mes == 10)
        return "Noviembre";
    else if (mes == 11)
        return "Diciembre";
    else
        return "";
}

export function GetEstadoString(estado) {

    if (estado == EstadoPedido.Procesando)
        return "Procesando";
    else if (estado == EstadoPedido.Tramitado)
        return "Tramitado";
    else if (estado == EstadoPedido.PendientePago)
        return "Pendiente de Pago";
    else if (estado == EstadoPedido.EnEspera)
        return "En Espera";
    else if (estado == EstadoPedido.Enviado)
        return "Enviado";
    else if (estado == EstadoPedido.Completado)
        return "Completado";
    else if (estado == EstadoPedido.Cancelado)
        return "Cancelado";
    else if (estado == EstadoPedido.Reembolsado)
        return "Reembolsado";
    else if (estado == EstadoPedido.Fallido)
        return "Fallido";
    else
        return "";

}

export function ImprimirListado(reportmode, listado, datosbusqueda, callGetDatosReport, callbackEnvioListadoMail) {

    if (callGetDatosReport != null && callGetDatosReport != "") {
        let selectedFormat = 'pdf';

        var formData = new FormData();

        for (var key in datosbusqueda) {
            formData.append(key, datosbusqueda[key]);
        }

        fetch(callGetDatosReport, {
            method: 'POST',
            body: formData
        }).then(response => response.json()).then(res => {
            //Si estamos con un resultado de tipo report
            if (res != null && res.idreport != null && res.idreport != "") {
                //Si estamos en preview
                if (reportmode == ModoReport.Preview) {
                    localStorage.setItem("pageListado", listado);
                    localStorage.setItem("pageData", res.idreport);

                    window.open('report') //to open new page
                }
                //si me dice imprimir
                else if (reportmode == ModoReport.Imprimir) {
                    var frameElement = window.open("api/Report/Print?name=" + listado + "&idreport=" + res.idreport, "_blank");
                    frameElement.addEventListener("load", function (e) {
                        if (frameElement.document.contentType !== "text/html")
                            frameElement.print();
                    });
                }
                else if (reportmode == ModoReport.Archivo) {
                    fetch("api/Report/Export?name=" + listado + "&idreport=" + res.idreport + "&format=" + this.selectedFormat)
                        .then(response => response.blob())
                        .then(data => {
                            saveAs(data, listado + '.' + selectedFormat.toLowerCase());
                        });
                }
                else if (reportmode == ModoReport.EMail) {

                    if (callbackEnvioListadoMail != null)
                        callbackEnvioListadoMail(res);
                    //  this.setState({ dialogEmailOpen: DataStateModal.dsOpen, dataidreportdialog: res.idreport });
                }
            }
            //else if (res != null && ((res.exceptionMessageTraducible != null && res.exceptionMessageTraducible != "") || (res.exceptionMessage != null && res.exceptionMessage != "")))
            // this.setState({ retornoCResultadoOthello: res });
        }).catch(error => {

        });
    }
}


export function ParseBase64ToBlob(base64Data, tipoFichero) {
    let tipo = "";

    if (tipoFichero == "csv")
        tipo = "text/csv";
    else if (tipoFichero == "png")
        tipo = "image/png";
    else
        tipo = "application/pdf";

    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min(begin + sliceSize, bytesLength);

        const bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }

    return new Blob(byteArrays, { type: tipo });
}

export function renderNotificaciones(datos) {

    let finales = datos.map(x => <MDAlert color="error" sx={{ boxShadow: 3 }}>

        <Icon fontSize="small">notifications_active</Icon>&nbsp;<MDTypography variant="button" color="white">{" "}{x.titulo}</MDTypography>
    </MDAlert>);

    return finales;
}

//botones->> MessageOthelloBoxButtons
export function MostrarRetorno(resultadoOthello, soloIncidencia, onCloseResulRetorno, botones, textobotones, mostrarAlertOk) {
    //Si el resultado no fue valido y no solo queremos que trate incidencias
    if ((resultadoOthello.resultado != TiposResultadoOthello.Ok && !soloIncidencia) || (resultadoOthello.incidencias != null && resultadoOthello.incidencias.length >= 1))
        return <OthelloMostrarRetorno resultadoOthello={resultadoOthello} soloIncidencia={soloIncidencia} botones={botones} textobotones={textobotones} onCloseResulRetorno={onCloseResulRetorno} />
    else if (mostrarAlertOk && resultadoOthello.resultado == TiposResultadoOthello.Ok)
        return <OthelloPopUpResult alert={PopUpResult.OK} onClosePopUpResult={onCloseResulRetorno} />
    else
        return "";
}


export function MontarTextoResultadoTraducido(resultadoOthello, t) {

    var Literal = "";

    //Si se trata de un CResultadoOthello
    if (resultadoOthello != null) {
        //Si tiene un mensaje de error traducible
        if (resultadoOthello.exceptionMessageTraducible != null && resultadoOthello.exceptionMessageTraducible != "") {
            Literal = t(resultadoOthello.exceptionMessageTraducible);

            //Si tiene valores
            //if (Res.ValoresExceptionMessageTraducible != null) {
            //    try {
            //        //Monto los parametros del string 
            //        return string.Format(Literal, Res.ValoresExceptionMessageTraducible);
            //    }
            //    catch
            //    {
            //        return Literal;
            //    }
            //}
            ////Sino tiene valores
            //else
            //    return Literal;
        }
        //Sino si tiene un warning traducible
        else if (resultadoOthello.warningMessageTraducible != null && resultadoOthello.warningMessageTraducible != "") {
            Literal = t(resultadoOthello.warningMessageTraducible);

            //Si tiene valores
            //if (Res.ValoresWarningMessageTraducible != null) {
            //    try {
            //        //Monto los parametros
            //        return string.Format(Literal, Res.ValoresWarningMessageTraducible);
            //    }
            //    catch
            //    {
            //        return Literal;
            //    }
            //}
            //else
            //    return Literal;
        }
        //Si tiene un array de warning
        else if (resultadoOthello.warningDic != null && resultadoOthello.warningDic.length > 0) {
            Literal = "";
            resultadoOthello.warningDic.forEach(x => Literal += t(x.codigoLiteralMessage) + "\r\n");


            //foreach(WarningUsuario valor in Res.WarningDic)
            //{
            //    //Obtengo el literal
            //    String Literal = NSClasesOthello.PlugIn.Preferencias.Literales.TomarLiteral(valor.CodigoLiteralMessage, valor.MessageDefault) + "\r\n";

            //    //Si tiene valores 
            //    if (valor.ValoresMessage != null) {
            //        try {
            //            //Monto los parametros
            //            resul += string.Format(Literal, valor.ValoresMessage);
            //        }
            //        catch
            //        {
            //        }
            //    }
            //    //Sino le añado normal
            //    else
            //        resul += Literal;
            //}           
        }
        else if (resultadoOthello.exceptionMessage != null && resultadoOthello.exceptionMessage != "")
            Literal = resultadoOthello.exceptionMessage;
    }

    return Literal;
}

export function MensajeModalSegunEstado2(modo, literal, textodelete) {

    if (modo == ModoModal.Undo || modo == ModoModal.Back)
        return (<div>{literal('_undoback')}</div>);
    else if (modo == ModoModal.Delete)
        return textodelete != null ? literal(textodelete) : literal('_deleteopc');
    else
        return ("");
}

export function GetGoogleMaps(latitud, longitud) {
    const MapWrapper = withScriptjs(
        withGoogleMap((props) => (
            <GoogleMap
                defaultZoom={17}
                defaultCenter={{ lat: latitud, lng: longitud }}
                defaultOptions={{
                    styles: [
                        {
                            featureType: "water",
                            elementType: "geometry",
                            stylers: [
                                {
                                    color: "#e9e9e9",
                                },
                                {
                                    lightness: 17,
                                },
                            ],
                        },
                        {
                            featureType: "landscape",
                            elementType: "geometry",
                            stylers: [
                                {
                                    color: "#f5f5f5",
                                },
                                {
                                    lightness: 20,
                                },
                            ],
                        },
                        {
                            featureType: "road.highway",
                            elementType: "geometry.fill",
                            stylers: [
                                {
                                    color: "#ffffff",
                                },
                                {
                                    lightness: 17,
                                },
                            ],
                        },
                        {
                            featureType: "road.highway",
                            elementType: "geometry.stroke",
                            stylers: [
                                {
                                    color: "#ffffff",
                                },
                                {
                                    lightness: 29,
                                },
                                {
                                    weight: 0.2,
                                },
                            ],
                        },
                        {
                            featureType: "road.arterial",
                            elementType: "geometry",
                            stylers: [
                                {
                                    color: "#ffffff",
                                },
                                {
                                    lightness: 18,
                                },
                            ],
                        },
                        {
                            featureType: "road.local",
                            elementType: "geometry",
                            stylers: [
                                {
                                    color: "#ffffff",
                                },
                                {
                                    lightness: 16,
                                },
                            ],
                        },
                        {
                            featureType: "poi",
                            elementType: "geometry",
                            stylers: [
                                {
                                    color: "#f5f5f5",
                                },
                                {
                                    lightness: 21,
                                },
                            ],
                        },
                        {
                            featureType: "poi.park",
                            elementType: "geometry",
                            stylers: [
                                {
                                    color: "#dedede",
                                },
                                {
                                    lightness: 21,
                                },
                            ],
                        },
                        {
                            elementType: "labels.text.stroke",
                            stylers: [
                                {
                                    visibility: "on",
                                },
                                {
                                    color: "#ffffff",
                                },
                                {
                                    lightness: 16,
                                },
                            ],
                        },
                        {
                            elementType: "labels.text.fill",
                            stylers: [
                                {
                                    saturation: 36,
                                },
                                {
                                    color: "#333333",
                                },
                                {
                                    lightness: 40,
                                },
                            ],
                        },
                        {
                            elementType: "labels.icon",
                            stylers: [
                                {
                                    visibility: "off",
                                },
                            ],
                        },
                        {
                            featureType: "transit",
                            elementType: "geometry",
                            stylers: [
                                {
                                    color: "#f2f2f2",
                                },
                                {
                                    lightness: 19,
                                },
                            ],
                        },
                        {
                            featureType: "administrative",
                            elementType: "geometry.fill",
                            stylers: [
                                {
                                    color: "#fefefe",
                                },
                                {
                                    lightness: 20,
                                },
                            ],
                        },
                        {
                            featureType: "administrative",
                            elementType: "geometry.stroke",
                            stylers: [
                                {
                                    color: "#fefefe",
                                },
                                {
                                    lightness: 17,
                                },
                                {
                                    weight: 1.2,
                                },
                            ],
                        },
                    ],
                    scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
                }}
            >
                <Marker position={{ lat: latitud, lng: longitud }} />
            </GoogleMap>
        )));

    return <MapWrapper
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDTyawbO2Bp07flFyiB_34AMAE8Xw0AU00"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100%` }} />}
        mapElement={<div style={{ height: `100%` }} />}
    />
}


export function EstaCancelarDisponibleReserva(reserva, tipoinstalacion)
{
    let diaok = false;

    if (reserva != null && reserva.estado == EstadoReserva.Confirmada || reserva.estado == "Confirmada") {

        const fechaObjetivo = new Date(reserva.fecha);

        // Obtenemos la fecha actual y seteamos la hora a 00:00:00
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);

        diaok = (fechaObjetivo >= hoy);

        if (diaok) {
            //Si estamos con 
            if (tipoinstalacion == TiposInstalacionReserva.Horaria) {
                const fechahorainicio = new Date(reserva.fReserva);

                // Obtener la fecha y hora actual
                const now = new Date();

                // Verificar si 'now' está entre 'fechahorainicio' y 'fechahorafinalConMargen'
                const estaEntreFechas = now < fechahorainicio;

                return estaEntreFechas;
            }
            else
                return true;
        }
        else
            return false;
    }
    else
        return false;
}


export function EstaCheckoutDisponibleReserva(reserva, tipoinstalacion, concheckouthoraria)
{
    if (reserva != null && reserva.estado == EstadoReserva.Confirmada || reserva.estado == "Confirmada")
    {
        //Si estamos con 
        if (tipoinstalacion == TiposInstalacionReserva.Horaria && concheckouthoraria == 1) {
            const fechahorainicio = new Date(reserva.fReserva);
            const fechahorafinal = new Date(reserva.fFinalReserva);

            // Crear una nueva fecha y hora final sumando TimeMargenCheckOut
            const fechahorafinalConMargen = new Date(fechahorafinal);
            fechahorafinalConMargen.setMinutes(fechahorafinalConMargen.getMinutes() + reserva.timeMargenCheckOut);

            // Obtener la fecha y hora actual
            const now = new Date();

            // Verificar si 'now' está entre 'fechahorainicio' y 'fechahorafinalConMargen'
            const estaEntreFechas = now >= fechahorainicio && now <= fechahorafinalConMargen;

            return estaEntreFechas;
        }
        else
            return false;
    }
    else
        return false;
}

export function getBotonPagarPasarelaPago(id_Rol, pago, onClickRealizarPago) {

    let formulariopago = "";

    let pagocontado = "";

    if (pago != null) {
        if (id_Rol != null && (id_Rol == Roles.SuperUsuario || id_Rol == Roles.Administrador)) {
            pagocontado =
                <Grid item xs={6} sm={6} pr={1}>
                    <Button fullWidth color="twitter" href={pago.urlokcontado}>Pago Contado</Button>
                </Grid>
        } {/*component={Link} to={pago.urlokcontado}*/ }

        //Si estamos con Paygold
        if (pago.driver == "RedSys") {
            formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver} method="post">
                <input runat="server" type="hidden" id="Ds_SignatureVersion" name="Ds_SignatureVersion" value={pago.ds_SignatureVersionGold} />
                <input runat="server" size="100" type="hidden" id="Ds_MerchantParameters" name="Ds_MerchantParameters" value={pago.ds_MerchantParametersGold} />
                <input runat="server" type="hidden" size="50" id="Ds_Signature" name="Ds_Signature" value={pago.ds_SignatureGold} />
                <Button fullWidth color="primary" type="submit" onClick={onClickRealizarPago}>Realizar Pago</Button>
            </form></Grid>)
        }
        else if (pago.driver == "PayComet") {
            formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver + "?" + pago.urlParametrosComet} method="post">
                <Button fullWidth color="primary" type="submit" onClick={onClickRealizarPago}>Realizar Pago</Button>
            </form></Grid>)
        }
        else if (pago.driver == "AddOnPayments") {
            formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver + "?" + pago.urlParametrosAddOn} method="post">
                <Button fullWidth color="primary" type="submit" onClick={onClickRealizarPago}>Realizar Pago</Button>
            </form></Grid >);
        }
        else if (pago.driver == "CecaBank") {
            formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena" action={pago.urlDriver + "?" + pago.urlParametrosCecabank} method="post" encType="application/x-www-form-urlencoded">
                <Button fullWidth color="primary" type="submit" onClick={onClickRealizarPago}>Realizar Pago</Button>
            </form></Grid>)
        }
        else if (pago.driver == "Paytef") {
            formulariopago = (<Grid item xs={6} sm={6} pr={1}><form id="formcadena">
                <Button fullWidth color="primary" type="submit" onClick={(e)=> onClickRealizarPago(e, pago)}>Realizar Pago</Button>
            </form></Grid>)
        }
            
    }

    return <Grid container xs={12} mt={1}>{formulariopago} {pagocontado}</Grid>;
}


